// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "stimulus";
import Clipboard from 'stimulus-clipboard';
import Sortable from 'sortablejs';
import { definitionsFromContext } from "stimulus/webpack-helpers";
import ColorPicker from '@stimulus-components/color-picker';
import './color_picker.css';

const application = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))
application.register('clipboard', Clipboard)
application.register('sortable', Sortable)
application.register('color-picker', ColorPicker)
